import { render, staticRenderFns } from "./SuccessMessage.vue?vue&type=template&id=0c21fac8&scoped=true&"
import script from "./SuccessMessage.vue?vue&type=script&lang=js&"
export * from "./SuccessMessage.vue?vue&type=script&lang=js&"
import style0 from "./SuccessMessage.vue?vue&type=style&index=0&id=0c21fac8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c21fac8",
  null
  
)

export default component.exports